import { Controller } from "react-hook-form";

import type { BaseQuestionProps, QuestionOption } from "../types";

import { FieldsetMultiChoice } from "./FieldsetMultiChoice";
import { IndexedCheckbox } from "./IndexedCheckbox";

type MultipleChoiceQuestionProps = {
  options: QuestionOption[];
} & BaseQuestionProps;

export function MultipleChoiceQuestion({
  control,
  errors,
  label,
  name,
  options,
  questionNumber,
}: MultipleChoiceQuestionProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FieldsetMultiChoice
          data-field-name={name}
          errorMessage={errors[name]?.message as string}
          isInvalid={!!errors[name]}
          label={label}
          onChange={field.onChange}
          questionNumber={questionNumber}
          value={field.value as string[]}
        >
          {options.map((option, idx) => (
            <IndexedCheckbox
              index={option.index || String(idx + 1)}
              key={option.value}
              label={option.label}
              value={option.value}
            />
          ))}
        </FieldsetMultiChoice>
      )}
    />
  );
}
